export const GET_FESTIVAL_COUNTRIES = 'app/Festivals/GET_FESTIVAL_COUNTRIES';
export const GET_FESTIVAL_YEARS = 'app/Festivals/GET_FESTIVAL_YEARS';
export const GET_FESTIVALS = 'app/Festivals/GET_FESTIVALS';
export const SEARCH_FESTIVALS = 'app/Festivals/SEARCH_FESTIVALS';
export const GET_FESTIVALS_PRODUCTIONS = 'app/Festivals/GET_FESTIVALS_PRODUCTIONS';
export const GET_FESTIVALS_WITH_PRODUCTIONS = 'app/Festivals/GET_FESTIVALS_WITH_PRODUCTIONS';
export const CLEAR_FESTIVALS_OPTIONS = 'app/Festivals/CLEAR_FESTIVALS_OPTIONS';
